import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgInstagramLogo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14.002 8.36A5.631 5.631 0 0 0 8.363 14a5.63 5.63 0 0 0 5.64 5.64A5.63 5.63 0 0 0 19.642 14a5.63 5.63 0 0 0-5.64-5.64Zm0 9.307A3.673 3.673 0 0 1 10.336 14a3.67 3.67 0 0 1 3.666-3.667A3.67 3.67 0 0 1 17.67 14a3.673 3.673 0 0 1-3.667 3.667Zm7.186-9.538c0 .731-.59 1.315-1.316 1.315a1.316 1.316 0 1 1 1.315-1.316Zm3.735 1.335c-.084-1.762-.486-3.323-1.777-4.61-1.286-1.286-2.847-1.688-4.609-1.777-1.816-.103-7.258-.103-9.074 0-1.757.084-3.318.486-4.609 1.772-1.29 1.287-1.688 2.848-1.777 4.61-.103 1.816-.103 7.26 0 9.077.084 1.762.486 3.323 1.777 4.61 1.29 1.286 2.847 1.688 4.609 1.777 1.816.103 7.258.103 9.074 0 1.762-.084 3.323-.486 4.609-1.777 1.286-1.287 1.688-2.848 1.777-4.61.103-1.816.103-7.256 0-9.072Zm-2.346 11.02a3.712 3.712 0 0 1-2.091 2.092c-1.448.575-4.884.442-6.484.442-1.6 0-5.04.128-6.483-.442a3.712 3.712 0 0 1-2.09-2.091C4.853 19.037 4.986 15.6 4.986 14c0-1.6-.128-5.042.441-6.485A3.712 3.712 0 0 1 7.52 5.424c1.448-.575 4.883-.442 6.483-.442 1.6 0 5.04-.128 6.484.442a3.712 3.712 0 0 1 2.09 2.091c.575 1.448.442 4.885.442 6.485 0 1.6.133 5.042-.441 6.485Z" />
  </svg>
);
export default SvgInstagramLogo;
